import { CustomAlertDialog } from "../../../../../components/Dialogs/CustomAlertDialog";

import { VACATION_REQUESTS_STRINGS } from "../constants/strings";

type ApplyConfirmDialogPropsT = {
  open: boolean;
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
};

const ApplyConfirmDialog = ({
  open,
  count,
  onCancel,
  onConfirm,
}: ApplyConfirmDialogPropsT) => {
  const message =
    count === 1
      ? VACATION_REQUESTS_STRINGS.APPLY_CONFIRM_MESSAGE_SINGULAR
      : VACATION_REQUESTS_STRINGS.APPLY_CONFIRM_MESSAGE_PLURAL.replace(
          "{n}",
          String(count),
        );

  return (
    <CustomAlertDialog
      open={open}
      setOpen={(value: boolean) => {
        if (!value) onCancel();
      }}
      title={VACATION_REQUESTS_STRINGS.APPLY_CONFIRM_TITLE}
      message={message}
      agreeLabel={VACATION_REQUESTS_STRINGS.APPLY_CONFIRM_AGREE_LABEL}
      agreeIcon="pi pi-send"
      onCancelFunction={onCancel}
      onConfirmFunction={onConfirm}
      style={{ width: "32rem" }}
    />
  );
};

export default ApplyConfirmDialog;
